import { render, staticRenderFns } from "./FactoryMgmtView.vue?vue&type=template&id=01b87687"
import script from "./FactoryMgmtView.vue?vue&type=script&lang=js"
export * from "./FactoryMgmtView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports